<div class="container-fluid">
  <div class="row">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div class="mp-rm col-12" style="background-color:white!important;width:20px!important;">
      <label class="pull-leftt h5" style="margin-top:4px;"><b>No trip</b></label>
      <input type="checkbox" checked class="form-control form-control-sm mp-rm pull-left" (change)="changeState($event)" />
      <label class="lead pull-right" [ngClass]="{'text-danger':dataCtrl.today}"><b>{{dataCtrl.day}}</b></label>
    </div>        
    <div class="col-12" style="margin:0px;padding:0px;"><hr /></div>
    <div class="col-12 mp-rm">
      <button type="button" class="btn btn-link mp-rm" [disabled]="hasTrip" (click)="onShow()"><b class="text-danger">Forward</b></button>

    </div>
    <div class="col-12">Depart:</div>
    <div class="col-12">Border Post:</div>
    <div class="col-12">Border Post:</div>
    <div class="col-12">Destination:</div>
    <div class="col-12">Num Pax:</div>
    
  </div>
  <div class="col-12" style="margin:0px;padding:0px;"><hr /></div>
  <div class="row">
    <div class="col-12 mp-rm">
      <button type="button" class="btn btn-link mp-rm" [disabled]="hasTrip" (click)="onShow()"><b class="text-danger">Return</b></button>      
    </div>
    <div class="col-12">Depart:</div>
    <div class="col-12">Border Post:</div>
    <div class="col-12">Border Post:</div>
    <div class="col-12">Destination:</div>
    <div class="col-12">Num Pax:</div>
  </div>

  <div class="row">
    <div class="col-12">
      <!--Manage Timetable-->
      
        <div class="modal fade" id="Manager" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body modal-lg brd-a">
               
                <!--Trip form-->

                <div class="row">
                  <div class="col-12 brd-r" style="">

                    <form [formGroup]="tripForm" (ngSubmit)="onSubmit()">                                          
                      <div formArrayName="trips">
                        <div *ngFor="let skill of tripForm.get('trips')['controls']; let i=index">
                          <div [formGroupName]="i">

                            <div class="row">
                              <div class="col-6 brd-r">
                                <div class="row mrg-all">
                                  <div class="col-12 mp-rm">

                                    <label class="d-inline-block lbl-sz">
                                      <b class="d-inline-block wdt">
                                        Forward
                                      </b>
                                    </label>
                                  </div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Depart:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Border Post:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Border Post:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Destination:</label></div>
                                  <div *ngIf="!isFreight" class="input-group-text col-12 mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Num Pax:</b></label>
                                    <input type="number" formControlName="FNPax" class="form-control form-control-sm" min="0" />
                                  </div>
                                  <div *ngIf="isFreight" class="input-group-text col-12 mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Mass:</b></label>
                                    <input type="number" formControlName="FMass" checked class="form-control form-control-sm" min="0" />
                                  </div>
                                  <div *ngIf="isFreight" class="input-group-text col-12 mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Category:</b></label>
                                    <input type="text" formControlName="FCat" class="form-control form-control-sm" />
                                  </div>

                                  <div class="col-12 mp-rm">
                                    <div class="center row" style="height:100%!important;">

                                      <div class="col-12 mp-rm" style="height:auto;">
                                        <table class="table">
                                          <tbody class="upload-name-style">
                                            <tr *ngFor="let item of uploadFwds[i]; let f=index" style="border-bottom:none!important;">
                                              <td>
                                                <strong>{{ item.filename }}</strong>
                                                <input type="hidden" formControlName="FUploads" [ngModel]="item" />
                                                <input type="hidden" formControlName="tripNum" [ngModel]="i" />
                                              </td>
                                              <td class="td-sz">
                                                <span title="Delete Document" class="btn btn-danger btn-sm"><i class="fa fa-trash-o fa-fw"></i></span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div class="col-12 mp-rm">
                                        <file-drop class="drop-zone content" headertext="Drop your file to upload for forward trip here" (onFileDrop)="dropped($event,i,1)"
                                                   (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" customstyle="">
                                        </file-drop>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="row mrg-all">
                                  <div class="col-12 mp-rm">
                                    <label class="d-inline-block lbl-sz">
                                      <b class="d-inline-block wdt mp-rm">
                                        Return
                                      </b>
                                    </label>
                                  </div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Depart:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Border Post:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Border Post:</label></div>
                                  <div class="col-12 mp-rm"><label class="d-inline-block lbl-sz">Destination:</label></div>
                                  <div *ngIf="!isFreight" class="input-group-text col-12 mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Num Pax:</b></label>
                                    <input type="number" formControlName="RNPax" class="form-control form-control-sm" min="0" />
                                  </div>
                                  <div *ngIf="isFreight" class="input-group-text col-12 mp-rm mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Mass:</b></label>
                                    <input type="number" formControlName="RMass" checked class="form-control form-control-sm" min="0" />
                                  </div>
                                  <div *ngIf="isFreight" class="input-group-text col-12 mp-rm" style="background-color:white!important;border:none!important;">
                                    <label class="lbl-sz text-left"><b>Category:</b></label>
                                    <input type="text" formControlName="RCat" class="form-control form-control-sm" />
                                  </div>

                                  <div class="col-12 mp-rm">
                                    <div class="center row" style="height:100%!important;">

                                      <div class="col-12 mp-rm" style="height:auto;">
                                        <table class="table">
                                          <tbody class="upload-name-style">
                                            <tr *ngFor="let item of uploadRtns[i]; let r=index" style="border-bottom:none!important;">
                                              <td>
                                                <strong>{{ item.filename}}</strong>
                                                <input type="hidden" formControlName="RUploads" [ngModel]="item" />
                                                <input type="hidden" formControlName="tripNum" [ngModel]="i" />
                                              </td>
                                              <td class="td-sz">
                                                <span title="Delete Document" class="btn btn-danger btn-sm"><i class="fa fa-trash-o fa-fw"></i></span>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div class="col-12 mp-rm">
                                        <file-drop class="drop-zone content" headertext="Drop your file to upload for return trip here" (onFileDrop)="dropped($event,i,2)"
                                                   (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" customstyle="">
                                        </file-drop>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 mp-rm">                                
                                <button type="button" class="btn btn-link mp-rm"  (click)="removeTrip(i)"><blockquote class="text-danger">Remove compliance trip number {{i + 1}}</blockquote></button>
                              </div>
                              </div>
                              
                            </div>
                        </div>
                      </div>                     
                    </form>                                       
                  </div>
                </div>

                    <!--End trip form-->
                  </div>
                  <div class="modal-footer mp-rm">
                    <div class="row mp-rm">
                      <div class="col-12 mp-rm-1">
                        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="onClose()">Close</button>
                        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="processFiles()" style="">Save and next</button>
                        <button title="Add a new trip compliance" class=" btn-add btn btn-primary pull-right btn-md mr-2 mt-2"  (click)="addTrip()"><i class="fa fa-plus fa-2x" aria-hidden="true"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>  
</div>


